export default __webpack_public_path__ + "static/media/unsplash_XgeZu2jBaVI.79c4e258.jpg";